import { render, staticRenderFns } from "./SelectTeacher.vue?vue&type=template&id=39ec0d9e&scoped=true&"
import script from "./SelectTeacher.vue?vue&type=script&lang=js&"
export * from "./SelectTeacher.vue?vue&type=script&lang=js&"
import style0 from "./SelectTeacher.vue?vue&type=style&index=0&id=39ec0d9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ec0d9e",
  null
  
)

export default component.exports